var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TinyMceEditor',{attrs:{"id":"input-editor","value":_vm.value,"init":_vm.options},on:{"input":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }